import {useParams} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useSetupIntent} from '../hooks/useSetupIntent';
import {useEditPageTools} from '../hooks/useEditPageTools';


export const EditPage = () => {

    const {id: setupIntentId} = useParams();

    if (typeof setupIntentId === 'undefined') {
        throw new Error('setupIntentId is required parameter');
    }

    const {
        mode,
        tools,
    } = useEditPageTools();

    const {
        record: setupIntent,
        loading,
        updateRecord,
    } = useSetupIntent(setupIntentId);

    if (loading || !setupIntent) {
        return <PlatformLoader message='Loading setup intent...Please wait'/>;
    }

    return (
        <FormPageLayout
            title={setupIntent.description ? setupIntent.description : setupIntent.id}
            pageNavigation={<EditPageNavigation component={setupIntent}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 4
                    }}>
                        <Profile record={setupIntent}/>
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 8
                    }}>

                        <SimplePageContentWrapper>
                            {null}
                        </SimplePageContentWrapper>

                    </Grid.Col>
                </Grid>

                :
                <SimplePageContentWrapper>
                    <RecordForm
                        record={setupIntent}
                        handleSubmit={updateRecord}
                    />
                </SimplePageContentWrapper>
            }


        </FormPageLayout>
    );
};
